import { api } from './utils';
import type { MarketIdentifiers } from '$lib/types/market';

export async function fetchFundingRatePoints(
	marketIdentifier: MarketIdentifiers,
	startTimestamp: number,
	endTimestamp: number
) {
	if (!marketIdentifier || !startTimestamp || !endTimestamp) return;
	const response = await api(
		'get',
		`snx-perps/markets/${marketIdentifier}/time-series-data?startTimeMillis=${startTimestamp}&endTimeMillis=${endTimestamp}`
	);
	if (response.status === 200) {
		const data = await response.json();
		return data;
	}
}
